//常量类记录消息id
export const LANCHANGE = 'lanchange'; //切换国际化
export const THEMCHANGE = 'themchange'; //切换主题
export const UNIT = 'unit'; //切换单位
export const GETLENGTH = 'getlength'; //获取列表长度
export const HUAZHUAN = 'huazhuan'; //划转成功
export const OFFLINE = 'offline'; //断网
export const ONLINE = 'online'; //连接成功
export const LOGINOUT = 'loginout'; //退出登录
export const LOGIN = 'login'; //登录
export const FreshUrlParam = 'freshUrlParam'; //是否开通合约
export const ContractOpen = 'contractOpen'; //是否开通合约
export const HTTPCODEERR = 'httpCodeErr'; //http code码异常错误 非0 不包含退出登录情况
export const HTTPSTATUSERR = 'httpStatusErr'; //http status码异常错误 非200
export const HTTPFAULTERR = 'httpFaultErr'; //http 请求失败
export const SCREENSIZE = 'screensize'; //屏幕尺寸发生变化
export const CODECHANGE = 'codechange'; //切换合约
export const WSDATA = 'wsdata'; //socket数据
export const CODELIST = 'codelist'; //获取合约列表
export const CODELISTRATE = 'codelistrate'; //获取合约列表资金费率
export const CODELISTPRICE = 'codelistprice'; //合约列表最新价
export const DEEPDATA = 'deepdata'; //深度数据
export const KLINEDATA = 'klinedata'; //k线数据
export const PKSIZE = 'pksize'; //盘口尺寸发生变化
export const PKWTGDDATA = 'pkwtgddata'; //获取盘口委托挂单
export const PKWTCLICK = 'pkwtclick'; //盘口委托点击事件
export const PKSSCJEDATA = 'pksscjdata'; //获取盘口实时成交

export const GETURL = 'geturl'; //获取url地址
export const CHANGE_MODE = 'change_mode'; //修改模式

//=====================交易
export const TRADE_CCLIST_DATA = 'trade_cclist_data'; //获取持仓列表数据
export const TRADE_CCLIST_TYJ_DATA = 'trade_cclist_tyj_data'; //获取体验金持仓列表数据
export const TRADE_WTLIST_DATA = 'trade_wtlist_data'; //获取委托列表数据
export const TRADE_WTLIST_TYJ_DATA = 'trade_wtlist_tyj_data'; //获取体验金委托列表数据
export const TRADE_JHWTLIST_DATA = 'trade_jhwtlist_data'; //获取计划委托列表数据
export const TRADE_JHWTLIST_TYJ_DATA = 'trade_jhwtlist_tyj_data'; //获取计划委托体验金列表数据
export const TRADE_LSLIST_DATA = 'trade_lslist_data'; //获取历史列表数据
export const TRADE_LSLIST_TYJ_DATA = 'trade_lslist_tyj_data'; //获取历史体验金列表数据
export const TRADE_ZDLIST_DATA = 'trade_zdlist_data'; //获取账单列表数据
export const TRADE_TAKE = 'trade_take'; //监听各种下单http请求结果

//======================体验金相关
export const TRADE_TYJLIST_DATA = 'trade_tyjlist_data'; //获取合约体验金

//=====================下单
export const CHANGE_TRADE_TYPE = 'change_trade_type'; //修改交易类型
export const ORDER_ACCOUNTS_BALANCES_DATA = 'place_order_accounts_balances'; //获取用户可用余额等资产
export const POP_KAITONG_ACCOUNT = 'popkaitongaccount'; //开通用户账号

//=====================获取设置分仓合仓状态
export const GETFENORHECANG = 'getfenorhecang'; //获取分仓或合仓状态
export const SETFENORHECANG = 'setfenorhecang'; //设置分仓或合仓状态

//=====================获取设置逐仓全仓状态
export const GETZHUORQUANCANG = 'getzhuorquancang'; //获取逐仓或者全仓状态
//设置逐仓或全仓状态用的TRADE_TAKE

//======================跟单
export const GetMerchandiserTeacher = 'GetMerchandiserTeacher'; //获取交易员老师列表
export const MerchandiserMyTeacher = 'MerchandiserMyTeacher'; //获取我的交易员列表
export const GetMerchandiserBecomeLeader = 'GetMerchandiserBecomeLeader'; //申请成为交易员
export const GetMerchandiserFollowProfit = 'GetMerchandiserFollowProfit'; //今日收益、累计收益，头像，昵称，签名
export const GetMerchandiserLeaderShare = 'GetMerchandiserLeaderShare'; //交易员分成
export const GetMerchandiserCurrentFollowList = 'GetMerchandiserCurrentFollowList'; //当前跟单
export const GetMerchandiserHistoryFollowList = 'GetMerchandiserHistoryFollowList'; //历史跟单
export const GetMerchandiserLeaderTransactionData = 'GetMerchandiserLeaderTransactionData'; //老师交易数据
export const GetMerchandiserLeaderDetail = 'GetMerchandiserLeaderDetail'; //老师详情
export const GetMerchandiserLeaderCurrentFollowList = 'GetMerchandiserLeaderCurrentFollowList'; //老师订单当前带单
export const GetMerchandiserLeaderHistoryFollowList = 'GetMerchandiserLeaderHistoryFollowList'; //老师订单历史带单
export const GetMerchandiserLeaderFollow = 'GetMerchandiserLeaderFollow'; //老师跟随者
export const GetMerchandiserVacancyRemind = 'GetMerchandiserVacancyRemind'; //空位提醒
export const GetMerchandiserSettingLeaderDetail = 'GetMerchandiserSettingLeaderDetail'; //带单老师详情
export const GetMerchandiserFollowSettingEcho = 'GetMerchandiserFollowSettingEcho'; //修改带单设置回显
export const GetMerchandiserSetting = 'GetMerchandiserSetting'; //设置带单设置
export const GetMerchandiserCancelFollow = 'GetMerchandiserCancelFollow'; //取消跟随
export const GetMerchandiserAccountDetail = 'GetMerchandiserAccountDetail'; //账户详情
export const GetMerchandiserLeaderConfig = 'GetMerchandiserLeaderConfig'; //带单设置
export const GetMerchandiserGetFollowList = 'GetMerchandiserGetFollowList'; //正在跟随和历史跟随
export const GetMerchandiserStopFollow = 'GetMerchandiserStopFollow'; //取消用户跟随
export const GetMerchandiserGetTransactionData = 'GetMerchandiserGetTransactionData'; //交易员的交易数据
export const GetMerchandiserSetStatus = 'GetMerchandiserSetStatus'; //交易员设置带单状态
export const GetMerchandiserGetHistoryPositionList = 'GetMerchandiserGetHistoryPositionList'; //交易员历史带单
export const GetMerchandiserGetCurrentPositionList = 'GetMerchandiserGetCurrentPositionList'; //交易员当前带单
export const GetMerchandiserGetUserProfit = 'GetMerchandiserGetUserProfit'; //获取交易员相关信息
export const GetMerchandiserGetCurrentUserLeader = 'GetMerchandiserGetCurrentUserLeader'; //获取当前用户的交易员
export const GetFollowLeverageRange = 'GetFollowLeverageRange'; //获取当前用户的杠杆倍率
export const GetMerchandiserHistoryPositionList = 'GetMerchandiserHistoryPositionList'; //仓位历史
export const GetMerchandiserGetUserInfo = 'GetMerchandiserGetUserInfo'; //获取用户信息
export const GetMerchandiserGetCountryPhoneCodeList = 'GetMerchandiserGetCountryPhoneCodeList'; //区号列表
export const GetMerchandiserGetLeaderConfig = 'GetMerchandiserGetLeaderConfig'; //获取带单设置
export const GetMerchandiserRotationChart = 'GetMerchandiserRotationChart'; //获取首页轮播图
export const GetMerchandiserInstruments = 'GetMerchandiserInstruments'; //获取币对列表
//自选
export const SETCODESELF = 'setcodeself'; //自选
//复制命令
export const COPY = 'copy';

// export const COIN_ACCOUNT = [
//   { id: 1, name: "现货账户", key: "SPOT" },
//   { id: 2, name: "买币账户", key: "OTC" },
//   { id: 3, name: "合约账户", key: "CONTRACT" },
//   // { id: 4, name: "盈利账户", key: "MARGIN" },
//   // { id: 5, name: "币贷宝账户", key: "COIN_LOAN" },
//   { id: 6, name: "资产账户", key: "WEALTH" },
//   { id: 7, name: "跟单账户", key: "FOLLOW" },
//   { id: 8, name: "赠金账户", key: "PROFIT" },
//   // { id: 7, name: "定活期理财", key: "FINANCIAL" },
// ]

export const accountType = ['WEALTH', 'SPOT', 'OTC', 'CONTRACT']

//license 地址，参考准备工作部分，在视立方控制台申请 license 后可获得 licenseUrl
// export const licenseUrl = 'https://1335111377.trtcube-license.cn/license/v2/1335111377_1/v_cube.license'
export const licenseUrl = 'https://1386905489.trtcube-license.cn/license/v2/1386905489_1/v_cube.license'
export const SDKAppID = 1600114595


// WEBPACK FOOTER //
// ./src/assets/js/common/constant.js